export class OrderCambioEstadoRequest{
    adminId: string;
    observation: string;
    orderId: string;
    stateActualId: string;
    stateNewId: string;
}